import { VueCookieNext } from '@shining3d/vue-cookie-next';
import info from './api';
import _get from 'lodash/get.js';
import { $getLocalStorage, $setLocalStorage, $checkPerm } from '@shining3d/common-module/utils/index';

export default {
  state:{
		userInfo: $getLocalStorage( 'userInfo' ) || {}, // 用户信息
		privacyPolicySwitchInfo: false, // 隐私政策
		termsOfUseSwitchInfo: false, // 使用条款
		dataMigrateSwitchInfo: false, // 数据迁移声明
		orgDissolveNoticeSwitchInfo: false, // 机构解散须知
		factoryObjs: $getLocalStorage( 'countryList' ) || [], // 所属机构列表（所有状态）
		permsList: $getLocalStorage( 'perms' ) || {}, // 用户权限点
		factorySelect: $getLocalStorage( 'currentOrganization' ) || {}, // 当前选中机构
		applyCancelOn: '' // 用户注销信息
  },
  mutations: {
    // 个人信息
    setUserInfo( state, val ) {
			// 标题存储
			if ( val.nickName ) {
				VueCookieNext.setCookie( 'uTitle', val.nickName, { domain: _get( window, 'app.global.domain', '' ), expire: '3d', path: '/' });
			}
			// 案例下载使用，后续全部接入新项目使用userInfo中的参数
			$setLocalStorage( 'defaultDentalOrderReceive', val.defaultDentalOrderReceive || false );
			$setLocalStorage( 'userInfo', val );
			state.userInfo = val;
		},
    // 隐私政策
    setPrivacyPolicySwitchInfo( state, val ) {
			state.privacyPolicySwitchInfo = !state.privacyPolicySwitchInfo;
		},
		// 使用条款
		setTermsOfUseSwitchInfo( state, val ) {
			state.termsOfUseSwitchInfo = !state.termsOfUseSwitchInfo;
		},
    // 数据迁移声明
    setDataMigrateSwitchInfo( state, val ) {
			state.dataMigrateSwitchInfo = !state.dataMigrateSwitchInfo;
		},
		// 机构解散须知
		setOrgDissolveNoticeSwitchInfo( state, val ) {
			state.orgDissolveNoticeSwitchInfo = !state.orgDissolveNoticeSwitchInfo;
		},
    // 机构选中切换
		setFactorySelect( state, val ) {
			$setLocalStorage( 'currentOrganization', val );
			state.factorySelect = val;
		},
    // 权限列表存储
		setPermsList( state, val ) {
			$setLocalStorage( 'perms', val );
			state.permsList = val;
		},
    // 机构列表
		setFactoryObjs( state, val ) {
			// 获取当前选中机构
			let currentOrganization = val.find(( item ) => item.lastState === 'y' );
			// 判断选择机构不存在且为超管则直接赋值选择全部
			if ( !currentOrganization && $checkPerm( 'dental.admin_dental_order', state.permsList )){
				currentOrganization = { factoryType: 'all', id: 'all', lastState: 'y', name: '全部机构' };
			}
			// 选中机构存储
			this.commit( 'setFactorySelect', currentOrganization || {});
			$setLocalStorage( 'factoryObjs', val );
			state.factoryObjs = val;
		},
    // 用户注销信息
		setApplyCancelOn( state, val ) {
			state.applyCancelOn = val;
		},
  },
	actions: {
    // 获取用户注销信息
		getCancelInfo({ commit }, callback ) {
			info.cancelInfo().then(( res ) => {
				if ( res.status === 'success' ) {
					commit( 'setApplyCancelOn', _get( res, 'result.cancelEffectiveOn' ));
				} else {
					commit( 'setApplyCancelOn', '' );
				}
				if ( callback ) {
					callback();
				}
			});
		}
	},
}
